import { RouteRecordRaw } from 'vue-router';

const Layout = () => import('@/layout/index.vue');
const View = () => import('@/pages/agreement/components/View.vue');
const agreementRouter: RouteRecordRaw = {
    path: '/agreement',
    component: Layout,
    name: 'agreement',
    children: [
        {
            path: '',
            name: 'agreement-index', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/agreement/index.vue'),
            meta: {
                title: '协议'
            }
        }
    ]
};
const agreementViewRouter: RouteRecordRaw = {
    path: '/agreement/view',
    component: View,
    name: 'agreementView',
    meta: {
        title: () => { return '协议详情'; }
    }

};

export {
    agreementRouter,
    agreementViewRouter
};

